

export function MainInfo() {
  return (
    <p style={{ fontFamily: "DM-Merabi_1" }} className="main">
      მე ვარ ხათუნა გურეშიძე, პირველ რიგში ვარ ადამიანი და შემდეგ ექიმი.
      ცხოვრებას იმედის თვალით ვუყურებ და მინდა გითხრათ, რომ ეს ცხოვრება არ იქნება ფერადი,
      თუ შენ არ დახატე ლამაზი ფერებით. ხოდა გაუღიმეთ ცხოვრებას, ის მშვენიერია.
    </p>
  );
}